{
    "XrBUYZrUJIeOmy7Rb3T31": {
        "position": {
            "x": 22,
            "y": 20,
            "z": 1
        },
        "templateKey": "jobs/dagger",
        "jobKey": "dagger",
        "affiliation": "good",
        "key": "XrBUYZrUJIeOmy7Rb3T31",
        "maxhealth": "40"
    },
    "QEAyqgnD6RG02i9EvLJaH": {
        "position": {
            "x": 19,
            "y": 18,
            "z": 1
        },
        "templateKey": "jobs/hammer",
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "QEAyqgnD6RG02i9EvLJaH"
    },
    "BJCHuDfpt668TSYj0EACr": {
        "position": {
            "x": 18,
            "y": 20,
            "z": 1
        },
        "templateKey": "jobs/hammer",
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "BJCHuDfpt668TSYj0EACr"
    },
    "kl0t9KWyb2wt6dmvcvhnO": {
        "position": {
            "x": 20,
            "y": 21,
            "z": 1
        },
        "templateKey": "jobs/hammer",
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "kl0t9KWyb2wt6dmvcvhnO"
    },
    "9JPoCIWhzQnWtyIPgXz69": {
        "position": {
            "x": 9,
            "y": 8,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "9JPoCIWhzQnWtyIPgXz69"
    },
    "o0ssbJ8vYplD7cYfiD7J3": {
        "position": {
            "x": 11,
            "y": 9,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "o0ssbJ8vYplD7cYfiD7J3"
    },
    "NexOVZKwjaPXTeMVZBRdV": {
        "position": {
            "x": 10,
            "y": 11,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "NexOVZKwjaPXTeMVZBRdV"
    },
    "wKMogt4OMJcAuzw4m5Kxs": {
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "templateKey": "jobs/swordknight",
        "jobKey": "swordknight",
        "affiliation": "bad",
        "key": "wKMogt4OMJcAuzw4m5Kxs",
        "maxhealth": "50"
    },
    "fMOWoWMITbc6BIVwDRulv": {
        "position": {
            "x": 14,
            "y": 19,
            "z": 1
        },
        "templateKey": "jobs/hammerknight",
        "jobKey": "hammerknight",
        "affiliation": "bad",
        "key": "fMOWoWMITbc6BIVwDRulv",
        "maxhealth": "50"
    },
    "U3uTMeCsGRPwi3CtKgkK0": {
        "position": {
            "x": 13,
            "y": 15,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "bad",
        "key": "U3uTMeCsGRPwi3CtKgkK0"
    },
    "RcNj3EkUWi8BYWsLknvA-": {
        "position": {
            "x": 16,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/spear",
        "jobKey": "spear",
        "affiliation": "bad",
        "key": "RcNj3EkUWi8BYWsLknvA-"
    },
    "Usy-rvaiIeMS7KbDAZNA4": {
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "Usy-rvaiIeMS7KbDAZNA4"
    },
    "g8AKPbYBesO9TRuIrZ4ph": {
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/hammer",
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "g8AKPbYBesO9TRuIrZ4ph"
    },
    "vHPI0mhF6xMY9LZ6tH_Y-": {
        "position": {
            "x": 16,
            "y": 15,
            "z": 1
        },
        "templateKey": "jobs/dagger",
        "jobKey": "dagger",
        "affiliation": "bad",
        "key": "vHPI0mhF6xMY9LZ6tH_Y-"
    },
    "1vGinndGN5_cML_VwkZaf": {
        "position": {
            "x": 8,
            "y": 10,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "good",
        "key": "1vGinndGN5_cML_VwkZaf",
        "maxhealth": "40"
    },
    "LMikB6BDHBMAoOsXhyLav": {
        "position": {
            "x": 7,
            "y": 9,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "good",
        "key": "LMikB6BDHBMAoOsXhyLav",
        "maxhealth": "40"
    },
    "nDtfF-6inhKlvn_63tzY7": {
        "position": {
            "x": 14,
            "y": 8,
            "z": 1
        },
        "templateKey": "jobs/swordknight",
        "jobKey": "swordknight",
        "affiliation": "bad",
        "key": "nDtfF-6inhKlvn_63tzY7",
        "maxhealth": "50"
    },
    "HCXhQLxP5R4Z93R8kt122": {
        "position": {
            "x": 21,
            "y": 19,
            "z": 1
        },
        "templateKey": "jobs/hammer",
        "jobKey": "hammer",
        "affiliation": "good",
        "key": "HCXhQLxP5R4Z93R8kt122",
        "maxhealth": "40"
    }
}